<template>
  <div class="lishizhang">

    <img src="../../../assets/img/xinxiang.jpg" alt="">

    <select style="WIDTH: 168px" id="4" class="select" onchange="window.open(this.options[this.selectedIndex].value,'_blank')"
      name="select4">
      <optgroup label="地方残联自有网站1"></optgroup>
      <option selected="selected">===地方残联自有网站===</option>
      <option title="即将打开北京网站" value="http://www.bdpf.org.cn">北京</option>


      <option title="即将打开天津网站" value="http://www.tjdpf.org.cn">天津</option>


      <option title="即将打开河北网站" value="http://www.hebcl.gov.cn">河北</option>


      <option title="即将打开山西网站" value="http://www.sxdpf.org.cn">山西</option>


      <option title="即将打开内蒙古网站" value="http://www.nmgcl.org.cn">内蒙古</option>


      <option title="即将打开辽宁网站" value="http://www.lncl.org.cn">辽宁</option>


      <option title="即将打开吉林网站" value="http://www.jldpf.org.cn">吉林</option>


      <option title="即将打开黑龙江网站" value="http://www.hljcl.gov.cn">黑龙江</option>


      <option title="即将打开上海网站" value="http://www.shdisabled.gov.cn">上海</option>


      <optgroup label="地方残联自有网站2"></optgroup>
      <option title="即将打开江苏网站" value="http://www.jscl.gov.cn">江苏</option>


      <option title="即将打开浙江网站" value="http://www.zjdpf.org.cn">浙江</option>

      <option title="即将打开安徽网站" value="http://www.ahdpf.org.cn">安徽</option>

      <option title="即将打开福建网站" value="http://www.1203.org">福建</option>

      <option title="即将打开江西网站" value="http://www.jxdpf.gov.cn">江西</option>

      <option title="即将打开山东网站" value="http://www.sdcl.org.cn">山东</option>


      <option title="即将打开河南网站" value="http://www.henancjr.org.cn">河南</option>

      <option title="即将打开湖北网站" value="http://www.hbdpf.org.cn">湖北</option>


      <option title="即将打开湖南网站" value="http://www.hndpf.org">湖南</option>


      <option title="即将打开广东网站" value="http://www.gddpf.org.cn">广东</option>


      <optgroup label="地方残联自有网站2"></optgroup>
      <option title="即将打开广西网站" value="http://www.gxdpf.org.cn">广西</option>


      <option title="即将打开海南网站" value="http://www.hidpf.org.cn">海南</option>


      <option title="即将打开重庆网站" value="http://www.cqdpf.org.cn">重庆</option>


      <option title="即将打开四川网站" value="http://www.scdpf.org.cn">四川</option>


      <option title="即将打开贵州网站" value="http://www.gzsdpf.org.cn">贵州</option>


      <option title="即将打开云南网站" value="http://www.cl.yn.gov.cn">云南</option>


      <option value="http://www.tdpf.org.cn">西藏</option>
      <option title="即将打开陕西网站" value="http://www.shxidpf.org.cn">陕西</option>


      <option title="即将打开甘肃网站" value="http://www.gsdpf.org.cn">甘肃</option>


      <option title="即将打开青海网站" value="http://www.qhcl.org">青海</option>


      <option value="http://www.ndpf.org.cn">宁夏</option>


      <optgroup label="地方残联自有网站3"></optgroup>
      <option value="http://www.xjdpf.gov.cn">新疆</option>


      <option title="即将打开新疆兵团网站" value="http://www.btdpf.org.cn">新疆兵团</option>


    </select>


    <select style="WIDTH: 168px" id="3" class="select" onchange="window.open(this.options[this.selectedIndex].value,'_blank')"
      name="select3">
      <optgroup label="省残联直属单位网站"></optgroup>
      <option selected="selected" value="">===省残联直属单位网站===</option>
      <option value="http://www.hnjjh.cn/">河南省残疾人福利基金会</option>


      <!-- <option value="http://www.hncjrjy.org.cn">河南省残疾人就业中心</option> -->
      <option value="http://www.henankf.com">河南省康复教育研究中心</option>
      <!-- <option value=" http://www.henanfuju.com/">河南省残疾人辅助器具中心</option> -->
    </select>

    <select style="WIDTH: 168px" id="Select1" class="select" onchange="window.open(this.options[this.selectedIndex].value,'_blank')"
      name="select">
      <optgroup label="省辖市残联网站"></optgroup>
      <option selected="selected" value="">===省辖市残联网站===</option>
      <option value="http://www.zzcjr.org.cn/">郑州市残疾人联合会</option>
      <option value="http://www.kfcjr.org.cn/">开封市残疾人联合会</option>
      <option value="http://www.luoyangcjr.org.cn/">洛阳市残疾人联合会</option>
      <option value="http://www.pdsdpf.org.cn/">平顶山市残疾人联合会</option>
      <option value="http://www.anyangcjr.org.cn/">安阳市残疾人联合会</option>
      <option value="http://www.smxcl.org.cn/">三门峡市残疾人联合会</option>
      <option value="http://www.xcscl.org.cn/">许昌市残疾人联合会</option>
      <option value="http://sqcl.gov.cn/">商丘市残疾人联合会</option>
      <option value="http://www.nycanlian.com/">南阳市残疾人联合会</option>
      <option value="http://www.xyscl.cn/">信阳市残疾人联合会</option>
    </select>


    <select style="WIDTH: 168px" id="2" class="select" onchange="window.open(this.options[this.selectedIndex].value,'_blank')"
      name="select2">
      <optgroup label="大型网络媒体网1"></optgroup>
      <option selected="selected" value="">===大型网络媒体网站===</option>
      <option title="即将打开新华网网站" value="http://www.xinhuanet.com/home.htm">新华网</option>
      <option title="即将打开人民网网站" value="http://www.people.com.cn">人民网</option>
      <option title="即将打开中央电视台网站" value="http://www.cctv.com">中央电视台</option>
      <option title="即将打开中国网网站" value="http://www.china.org.cn">中国网</option>
      <option title="即将打开中国广播网网站" value="http://www.cnr.cn">中国广播网</option>
      <option title="即将打开新浪网网站" value="http://www.sina.com.cn">新浪网</option>
      <option title="即将打开搜狐网" value="http://www.sohu.com">搜狐网</option>


      <option title="即将打开网易网" value="http://www.163.com">网易</option>


      <option title="即将打开北京青年报网站" value="http://www.ynet.com">北京青年报网</option>
    </select>

  </div>





  </div>
</template>

<script>
  export default {
    name: 'lishizhang',
    components: {},
    data() {
      return {
        optionA4: [{
            value: '0',
            label: '全部状态'
          },
          {
            value: '1',
            label: '正常运行'
          },
          {
            value: '2',
            label: '离线或故障'
          },
          {
            value: '3',
            label: '超标报警'
          }
        ],
      }
    },
    methods: {
      styleChange(val) {
        if (val == 0) {
          this.isShow1 = true,
            this.isShow2 = false
        } else {
          this.isShow1 = false
          this.isShow2 = true
        }
        var data = {}
        this.outfallType = val
        data.outfallType = this.outfallType
        getRealDataV2(data).then(val => {
          if (val.code === 200) {
            this.newData(val)
          }
        })
      },
    }
  };
</script>

<style scoped>
  .lishizhang {
    width: 200px;
  }

  .title {
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    text-align: left;
    color: #65A31E;
    font-weight: bold;
  }

  .box {
    display: flex;
    justify-content: flex-start;
    width: 100%;
    align-items: center;
    padding: 5px 0;
  }

  .box .ico {
    width: 30px;
    height: 30px;
  }

  .box .ico img {
    width: 24px;
    height: 24px;
  }

  .box .text {
    padding-left: 10px;
  }

  .select {
    width: 90%;
    padding: 6px 2px;
    margin: 5px 5%;
  }
</style>



// WEBPACK FOOTER //
// src/views/front/components/lishizhang.vue